import React from "react";

const AccountingCode = () => {
    return (
        <div>
            <h1>AccountingCode</h1>
        </div>
    );
}

export default AccountingCode;